import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const SafetyRibbon = () => {
  return (
    <div
      className="bg-green-100 border border-green-200 border-l-4 border-l-scoop-sage rounded-lg mb-8 p-3 md:p-4 flex items-start gap-3 fade-in"
      data-testid="safety-ribbon"
    >
      <ShieldCheck className="w-5 h-5 text-green-800 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <div className="text-sm text-green-800 leading-relaxed flex-1">
        <strong className="font-bold">Safe by design.</strong>{" "}
        Every story passes a three-step safety check before it reaches you.{" "}
        <Link
          to="/guidelines"
          className="font-bold underline underline-offset-2 hover:text-green-900 whitespace-nowrap"
          data-testid="safety-ribbon-guidelines-link"
        >
          How we keep it safe &rarr;
        </Link>
      </div>
    </div>
  );
};

export default SafetyRibbon;
